import { apiRequest } from '@/utils/request'

export function UpdateAuthLogByToken(data) {
  return apiRequest({
    url: '/AuthLog/UpdateAuthLogByToken',
    method: 'put',
    data: data
  })
}
